import { Component } from '@angular/core';

import { Platform, ModalController, MenuController, AlertController } from '@ionic/angular/standalone';
import { FirestoreService } from '../services/firestore.service';
import { TagsComponent } from '../components/tags/tags.component';

import * as xlsx from 'xlsx'

import { saveAs } from 'file-saver';
import { AuthService } from '../services/auth.service';
import { UIService } from '../services/ui.service';
import { SpreadsheetService } from 'src/services/spreadsheet.service';
import { NarrationIndexMeta, Transaction } from 'bankapp-types';
import { Router } from '@angular/router';
import { addIcons } from "ionicons";
import { arrowBack, menu, notificationsOutline, buildOutline, bug, exit, cloudUploadOutline, bookmark, pricetag, downloadOutline, trashBinOutline, contractOutline, archiveOutline, trashOutline, gridOutline, searchOutline } from "ionicons/icons";
import { SummaryComponent } from 'src/components/summary/summary.component';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {

    file
    arrayBuffer
    arraylist

    /** What the transaction menu says about the open account's search index */
    narrationIndexStatus: { built: boolean, detail: string, warn: boolean } = null

    /** True while the index metadata is being read, so the menu can say so rather than sit blank */
    narrationIndexChecking = false

    /** Which account and view narrationIndexStatus describes, so it isn't shown against another */
    private narrationIndexStatusKey: string = null

    constructor(
        private platform: Platform,
        public firestoreService: FirestoreService,
        public modalController: ModalController,
        public menuController: MenuController,
        public authService: AuthService,
        public uiService: UIService,
        private spreadsheetService: SpreadsheetService,
        private router: Router
    ) {
        this.initializeApp();
        addIcons({ arrowBack, menu, downloadOutline, notificationsOutline, buildOutline, bug, exit, cloudUploadOutline, bookmark, pricetag, trashBinOutline, contractOutline, archiveOutline, trashOutline, gridOutline, searchOutline });
    }

    initializeApp() {
        this.platform.ready().then(() => {
        });
    }

    openMenu(menuName: string) {
        this.menuController.open(menuName)
    }

    goBack() {
        if(this.firestoreService.currentBank?.bpayTransactionCounter && this.firestoreService.viewBpay) {
            this.firestoreService.switchBpay(false)
            return
        }
        this.router.navigate(["/"])
    }

    markForReview(review: boolean) {
        console.log("triggered2")
        this.firestoreService.bankAccountsLocal.map(async (x, index) => {
            if (this.firestoreService.checkedAccountsLocal[index]) {
                console.log(x)
                await this.firestoreService.updateBankAccount(x.bankId, { review: review, selected: true })
                //poor solution, sets the cloud to selected, which means it persists on refresh
            }
        })
    }

    assignSyndicate() {
        this.firestoreService.checkedTransactions.map(async (x, i) => {

        })
    }

    async tagAccount() {
        const checkedAccounts = []

        this.firestoreService.checkedAccountsLocal.map(async (x, i) => {
            if (x == true) {
                checkedAccounts.push(i)
            }
        })

        this.menuController.close("bankAccountMenu")
        const modal = await this.modalController.create({
            component: TagsComponent,
            cssClass: "transparent-modal",
            componentProps: { checked: checkedAccounts, isBankAccount: true }
        })

        await modal.present()
    }

    async tagTransaction() {
        const checkedTransactions = []

        this.firestoreService.checkedTransactions.map(async (x, i) => {
            if (x == true) {
                checkedTransactions.push(i)
            }
        })

        this.menuController.close("transactionMenu")
        const modal = await this.modalController.create({
            component: TagsComponent,
            cssClass: "transparent-modal",
            componentProps: { checked: checkedTransactions, isBankAccount: false }
        })

        await modal.present()
    }

    checkSelected() {
        return !this.firestoreService.checkedAccountsLocal.filter(x => x == true).length
    }

    fileInput(event) {
        this.file = event.target.files[0];
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(this.file);
        fileReader.onload = (e) => {
            this.arrayBuffer = fileReader.result;
            var data = new Uint8Array(this.arrayBuffer);
            var arr = new Array();
            for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
            var bstr = arr.join("");
            var workbook = xlsx.read(bstr, { type: "binary" });
            var first_sheet_name = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[first_sheet_name];
            this.arraylist = xlsx.utils.sheet_to_json(worksheet, { raw: true });
        }
    }

    isSameDay(time1, time2) {
        const date1 = new Date(time1)
        const date2 = new Date(time2)
        return (date1.getDate() == date2.getDate() && date1.getMonth() == date2.getMonth() && date1.getFullYear() == date2.getFullYear())
    }

    s2ab(s) {
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;
    }

    async exportAccounts(menuName: string) {
        const loading = await this.uiService.presentLoading("Exporting Accounts...")

        await this.menuController.close(menuName)
        const pluralString = this.firestoreService.checkedAccountsLocal.filter(x => x).length > 1 ? 's' : ''
        if (!await this.uiService.presentYesNoAlert(`Export Account${pluralString}`, `Are you sure you would like to export ${pluralString ? 'these' : 'this'} account${pluralString} to Excel? This will read every transaction in the selected account${pluralString}.`)) {
            return await this.menuController.open(menuName)
        }
        for (let i = 0; i < this.firestoreService.checkedAccountsLocal.length; i++) {
            const checked = this.firestoreService.checkedAccountsLocal[i]
            if(!checked) continue
            const bank = this.firestoreService.bankAccountsLocal[i]

            await this.exportAccount(bank.bankId, bank.bankName, true)
        }

        await loading.dismiss()
    }

    async exportAccount(bankId: string = this.firestoreService.currentBank.bankId, bankName: string = this.firestoreService.currentBank.bankName, isBulk = false) {
        let loading: HTMLIonLoadingElement
        if(!isBulk) {
            loading = await this.uiService.presentLoading("Exporting Transactions...")
        }
        const transactions = await this.firestoreService.getTransactions(bankId);
        let transactionArrayofArrays = [
            ["Date", "Transaction", "Type", "Narration", "Bank Balance", "Running Balance", "Index", "Recon", "Tags"],
            ...transactions.map(transaction => ([
                this.spreadsheetService.jsDateToExcel(+transaction.date),
                transaction.transaction,
                transaction.type,
                transaction.narration,
                transaction.bankBalance,
                transaction.runningBalance,
                transaction.index,
                transaction.recon,
                transaction.tags?.join(", ")
            ]))
        ];
        const ws = xlsx.utils.aoa_to_sheet(transactionArrayofArrays, { cellDates: true, dateNF: "d-mmm-yy" });
        let wb = xlsx.utils.book_new();
        wb.Props = {
            Title: bankName,
            Author: "Bank App",
            CreatedDate: new Date()
        };
        wb.SheetNames.push("Transactions");
        wb.Sheets["Transactions"] = ws;
        const wbout = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' });
        saveAs(new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }), `${bankName}.xlsx`);
        if(!isBulk && loading) {
            await loading.dismiss()
        }
    }

    async exportAccountWithUpdates(bankId: string = this.firestoreService.currentBank.bankId, bankName: string = this.firestoreService.currentBank.bankName) {
        const loading = await this.uiService.presentLoading("Exporting Transactions with Updates...")
        const transactions = await this.firestoreService.getTransactions(bankId);
        let transactionArrayofArrays = [
            ["Date", "Transaction", "Type", "Narration", "Bank Balance", "Running Balance", "Index", "Recon", "Tags", "Update Deal Name", "Update Path", "Update Index", "Update Entity ID"],
            ...transactions.map(transaction => ([
                this.spreadsheetService.jsDateToExcel(+transaction.date),
                transaction.transaction,
                transaction.type,
                transaction.narration,
                transaction.bankBalance,
                transaction.runningBalance,
                transaction.index,
                transaction.recon,
                transaction.tags?.join(", "),
                transaction.update?.dealName ?? "",
                transaction.update?.path ?? "",
                transaction.update?.index ?? "",
                transaction.update?.entityId ?? ""
            ]))
        ];
        const ws = xlsx.utils.aoa_to_sheet(transactionArrayofArrays, { cellDates: true, dateNF: "d-mmm-yy" });
        let wb = xlsx.utils.book_new();
        wb.Props = {
            Title: bankName,
            Author: "Bank App",
            CreatedDate: new Date()
        };
        wb.SheetNames.push("Transactions");
        wb.Sheets["Transactions"] = ws;
        const wbout = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' });
        saveAs(new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }), `${bankName}_with_updates.xlsx`);
        await loading.dismiss()
    }


    async importAccountCheck(fileInput: HTMLInputElement) {
        await this.menuController.close("transactionMenu")
        const response = await this.uiService.presentYesNoAlert('Import Transactions?', 'Are you sure you would like to import transactions into this account? This will overwrite any existing transactions with an index greater than the lowest index in your upload file.')
        if (response) {
            fileInput.click()
        } else {
            await this.menuController.open("transactionMenu")
        }
    }

    async importAccount(event: Event) {
        const target = event.target as HTMLInputElement
        const convertedSheet = await this.spreadsheetService.convertSpreadsheet(target.files[0])

        const headerMap: any = {
            "Bank Balance": "bankBalance",
            "Date": "date",
            "Index": "index",
            "Narration": "narration",
            "Running Balance": "runningBalance",
            "Transaction": "transaction",
            "Type": "type"
        }

        const optionalHeaders: any = {
            "Recon": "recon",
            "Tags": "tags"
        }

        const headers = Object.keys(headerMap)

        if (!(convertedSheet?.length && headers.every(key => convertedSheet[0].hasOwnProperty(key)))) {
            return this.uiService.presentOKAlert("Invalid Import", `The provided file is missing some required headers (<b>${headers.join(", ")}</b>)`)
        }

        const loading = await this.uiService.presentLoading("Importing Transactions...")

        const mappedSheet = convertedSheet
                            .map(t => Object.assign(t, { "Date": this.spreadsheetService.excelDateToJS(t["Date"])?.getTime() }))
                            .map(row => {
                                const transaction = new Transaction(Object.fromEntries(Object.entries(headerMap).map(([key, value]) => [value, row[key]])))

                                Object.entries(optionalHeaders).forEach(([key, value]: [string, string]) => {
                                    if (row[key]) {
                                        if(key === "Tags") {
                                            transaction.tags = row[key].split(",").map(x => x.trim())
                                        } else {
                                            transaction[value] = row[key]
                                        }
                                    }
                                })

                                return transaction
                            })


        await this.firestoreService.importTransactions(mappedSheet)

        await this.firestoreService.refreshTransactions()

        await loading.dismiss()

        target.value = ""
    }

    /**
     * Reads the index metadata for the open account so the menu can say whether an
     * index exists and how current it is. Costs a single document read, and the
     * read is forced because the server indexes transactions too, so a cached copy
     * can claim rows are unindexed that have since been covered.
     */
    async refreshNarrationIndexStatus() {
        const bank = this.firestoreService.currentBank
        if (!bank) {
            this.narrationIndexStatus = null
            this.narrationIndexStatusKey = null
            return
        }

        const bpay = this.firestoreService.viewBpay
        const key = `${bank.bankId}:${bpay}`
        // Reopening the same account's menu keeps the line it showed last time while
        // the read runs, so the label doesn't flicker between Build and Rebuild
        if (key !== this.narrationIndexStatusKey) this.narrationIndexStatus = null
        this.narrationIndexStatusKey = key
        this.narrationIndexChecking = true

        try {
            const meta = await this.firestoreService.narrationIndex.meta(bank.bankId, bpay, true)
            // The account or view can be switched while the read is in flight, and
            // describing one account's index under another's name is worse than silence
            if (this.narrationIndexStatusKey !== key) return
            this.narrationIndexStatus = this.describeNarrationIndex(meta, this.narrationIndexCounter(bank, bpay))
        } catch (error) {
            console.error(error)
            if (this.narrationIndexStatusKey === key) this.narrationIndexStatus = { built: false, detail: "Couldn't read the index", warn: true }
        } finally {
            this.narrationIndexChecking = false
        }
    }

    /** Transactions on the account, for the view the menu was opened over */
    private narrationIndexCounter(bank, bpay: boolean) {
        return (bpay ? bank.bpayTransactionCounter : bank.transactionCounter) ?? 0
    }

    /** One line summarising the index, matching the wording the search toasts use */
    private describeNarrationIndex(meta: NarrationIndexMeta | null, counter: number) {
        if (!meta) return { built: false, detail: "Not built — searches scan the account", warn: false }

        if (meta.needsRebuild) return { built: true, detail: "Needs rebuilding — transactions were renumbered", warn: true }

        const built = `Built ${this.formatIndexDate(meta.builtAt)}`
        // coveredThrough is the highest index covered, so the account is fully
        // covered once it reaches the last index, one below the counter
        const missing = Math.max(0, counter - 1 - (meta.coveredThrough ?? -1))

        if (missing) return {
            built: true,
            detail: `${built} · ${missing} newer transaction${missing === 1 ? "" : "s"} searched live`,
            warn: true
        }

        return { built: true, detail: `${built} · covers all ${counter} transactions`, warn: false }
    }

    /** dd/MM/yy, as the transaction tables print dates */
    private formatIndexDate(builtAt: number) {
        if (!builtAt) return "at an unknown time"
        const date = new Date(builtAt)
        const pad = (value: number) => String(value).padStart(2, "0")
        return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${String(date.getFullYear()).slice(-2)}`
    }

    /**
     * Builds the narration search index for the open account. Without it a
     * narration filter has to page the whole account; with it a search reads a
     * couple of dozen chunk documents and then only the rows it displays.
     */
    async buildNarrationIndex() {
        await this.menuController.close()

        const bank = this.firestoreService.currentBank
        if (!bank) return

        const bpay = this.firestoreService.viewBpay
        const counter = (bpay ? bank.bpayTransactionCounter : bank.transactionCounter) ?? 0
        const existing = await this.firestoreService.narrationIndex.meta(bank.bankId, bpay, true)

        const covered = existing ? (existing.coveredThrough ?? -1) + 1 : 0
        const proceed = await this.uiService.presentYesNoAlert(
            existing ? "Rebuild search index?" : "Build search index?",
            existing
                ? `This account already has an index covering ${covered} transactions of ${counter}. Rebuilding reads all ${counter} again and replaces it.`
                : `This reads all ${counter} transactions on this account once, then stores a compact copy of the narrations. Narration filtering will search the whole account instantly instead of paging through it.`,
            "Cancel",
            existing ? "Rebuild" : "Build"
        )
        if (!proceed) return

        const loading = await this.uiService.presentLoading("Reading transactions...")

        try {
            const result = await this.firestoreService.narrationIndex.build(bank.bankId, bpay, scanned => {
                loading.message = `Reading transactions... ${scanned}${counter ? ` of ${counter}` : ""}`
            })
            await loading.dismiss()
            // Force the next search to pick the new index up
            this.firestoreService.narrationSearchPrepared = false
            await this.refreshNarrationIndexStatus()
            await this.uiService.presentOKAlert(
                "Search index built",
                `Indexed ${result.scanned} transactions into ${result.chunks} chunk${result.chunks === 1 ? "" : "s"}.` +
                (result.removed ? ` Removed ${result.removed} stale chunk${result.removed === 1 ? "" : "s"}.` : "")
            )
        } catch (error) {
            console.error(error)
            await loading.dismiss()
            await this.uiService.presentOKAlert("Couldn't build the index", error?.message ?? "Something went wrong reading the transactions.")
        }
    }

    async clearNarrationIndex() {
        await this.menuController.close()

        const bank = this.firestoreService.currentBank
        if (!bank) return

        const proceed = await this.uiService.presentYesNoAlert("Clear search index?", "Narration filtering will fall back to scanning the account until the index is rebuilt.")
        if (!proceed) return

        const loading = await this.uiService.presentLoading("Clearing index...")
        try {
            const removed = await this.firestoreService.narrationIndex.clear(bank.bankId, this.firestoreService.viewBpay)
            this.firestoreService.narrationSearchPrepared = false
            await loading.dismiss()
            await this.refreshNarrationIndexStatus()
            await this.uiService.showToast(`Removed ${removed} index document${removed === 1 ? "" : "s"}`)
        } catch (error) {
            console.error(error)
            await loading.dismiss()
            await this.uiService.presentOKAlert("Couldn't clear the index", error?.message ?? "Something went wrong.")
        }
    }

    async removeRecon() {
        await this.menuController.close()

        const transactions = this.firestoreService.checkedTransactions.map((x, i) => x ? this.firestoreService.paginatedTransactions[i] : null).filter(x => x)

        const haveUpdates = transactions.some(x => x.update)

        const updates = []

        if(haveUpdates) {
            const updateOCL = await this.uiService.presentYesNoAlert("Update OCL?", "Are you sure you want to proceed? This will try to update the Outstanding Client Lists with the removed reconciliations. This is a potentially dangerous operation. Make sure you know what you're doing!")
            if(!updateOCL) return
        } else {
            const proceed = await this.uiService.presentYesNoAlert("Proceed?", "Are you sure you want to proceed?")
            if(!proceed) return 
        }

        const loading = await this.uiService.presentLoading("Removing Reconciliations...")

        await Promise.all(transactions.map(async transaction => {

            if(transaction.update) {
                updates.push({
                    ...transaction.update,
                    amount: -transaction.transaction,
                    date: transaction.date
                })
            }

            await this.firestoreService.updateTransaction(this.firestoreService.currentBank.bankId, transaction.id, { recon: "", tags: [] })
        }))

        /** Will only have length if there are updates */
        const uniquePaths = [...new Set(updates.map((x: any) => x.path))] as string[]

        for(let path of uniquePaths) {
            const relevantUpdates = updates.filter((x: any) => x.path === path)
            const updateBatch = {
                path,
                dealName: relevantUpdates[0].dealName ?? "",
                status: "toRun",
                updates: updates.filter((x: any) => x.path === path).reduce((acc, curr) => {
                    const existing = acc.find(x => x.entityId === curr.entityId && x.path === curr.path && x.index === curr.index);
                    if (existing) {
                        existing.amount += curr.amount;
                        existing.date = new Date(Math.max(new Date(existing.date).getTime(), new Date(curr.date).getTime())).getTime();
                    } else {
                        acc.push(curr);
                    }
                    return acc;
                }, [])
            }
            await this.firestoreService.addOCLUpdate(updateBatch)
        }

        await this.firestoreService.refreshTransactions()

        await loading.dismiss()

    }

    async mergeTransactions() {
        await this.menuController.close()

        const transactions = this.firestoreService.checkedTransactions.map((x, i) => x ? this.firestoreService.paginatedTransactions[i] : null).filter(x => x)

        const uniqueNarrations = [...new Set(transactions.map(x => x.narration))]

        const uniqueDates = [...new Set(transactions.map(x => x.date))]

        if(uniqueNarrations.length > 1 || uniqueDates.length > 1) {
            return this.uiService.presentOKAlert("Error", "Please select identical transactions to merge (same narration, same date).")
        }

        const proceed = await this.uiService.presentYesNoAlert("Proceed?", "Are you sure you want to proceed?")
        if(!proceed) return 

        const loading = await this.uiService.presentLoading("Merging Transactions...")

        const mergedTransaction = transactions.reduce((acc, val) => {
            return new Transaction({
                ...acc,
                transaction: acc.transaction + val.transaction,
                bankBalance: val.bankBalance,
                runningBalance: val.runningBalance,
                tags: [...new Set([...acc.tags ?? [], ...val.tags ?? []])]
            })
        })

        const indices = transactions.map(x => x.index)

        mergedTransaction.index = Math.min(...indices)

        await this.firestoreService.addTransaction(this.firestoreService.currentBank.bankId, mergedTransaction.toJson())

        await Promise.all(transactions.map(transaction => this.firestoreService.deleteTransaction(this.firestoreService.currentBank.bankId, transaction.id, undefined, transaction.index)))

        await this.firestoreService.updateIndicesAbove(Math.max(...indices), -(transactions.length - 1))

        await this.firestoreService.refreshTransactions()

        await loading.dismiss()
    }

    async deleteTransactions() {
        await this.menuController.close()
        const proceed = await this.uiService.presentYesNoAlert("Proceed?", "Are you sure you want to proceed? I don't need to tell you this is a destructive operation that can break things.")
        if(!proceed) return

        const updateBank = await this.uiService.presentYesNoAlert("Update Bank Balance?", "Would you like the bank balance to be recalculated (this may cause further problems, make sure you know what you are doing!")

        const loading = await this.uiService.presentLoading("Deleting Transactions...")

        const transactions = this.firestoreService.checkedTransactions.map((x, i) => x ? this.firestoreService.paginatedTransactions[i] : null).filter(x => x)

        const minIndex = Math.min(...transactions.map(x => x.index))

        await Promise.all(transactions.map(transaction => this.firestoreService.deleteTransaction(this.firestoreService.currentBank.bankId, transaction.id, undefined, transaction.index)))

        await this.firestoreService.reindexAndRebalanceAbove(minIndex - 1, updateBank)

        await this.firestoreService.refreshTransactions()

        await loading.dismiss()
    }

    async viewSummary(bpay = false) {
        
        await this.menuController.close()

        const proceed = await this.uiService.presentYesNoAlert("Proceed?", "Are you sure you want to proceed? This will read all transactions and take a while.")
        if(!proceed) return

        const loading = await this.uiService.presentLoading("Loading...")

        const transactions = await this.firestoreService.getTransactions(this.firestoreService.currentBank.bankId)
        const bpayTransactions = bpay ? await this.firestoreService.getTransactions(this.firestoreService.currentBank.bankId, [], true) : []

        const modal = await this.modalController.create({
            component: SummaryComponent,
            componentProps: {
                transactions,
                bpayTransactions
            },
            cssClass: "big-modal"
        })

        await loading.dismiss()

        await modal.present()
    }

    async signout(menuName: string) {
        await this.authService.signout()
        this.menuController.close(menuName)
    }

    async developerMode(menuName: string) {
        await this.menuController.close(menuName)
        if (await this.uiService.presentYesNoAlert('Developer Mode?', 'Are you sure you want to enter developer mode? You will be able to make potentially dangerous changes to the databases.')) {
            this.firestoreService.developer = true
        } else {
            this.menuController.open(menuName)
        }
    }

    async goUpdates() {
        this.menuController.close()
        await this.router.navigate(["/updates"])
    }
}
